import { useState, useEffect } from "react";

export default function useEventLoading(selectedEvent) {
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    if (!selectedEvent) return;

    const timer = setTimeout(() => setShowLoading(false), 300);
    return () => clearTimeout(timer);
  }, [selectedEvent]);

  return { showLoading };
}
